import { useEffect, useRef } from 'react';
import darkLogo from '../image/DarkLogo.svg';

interface ContainerProps {
  isHome: boolean;
}

const Header: React.FC<ContainerProps> = ({ isHome }) => {
  const mainDiv = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setTimeout(() => {
      if (mainDiv.current !== null) mainDiv.current.style.marginTop = '-30px';
    }, 2000);
  }, []);

  return (
    <div ref={mainDiv} className={`absolute top-0 h-${isHome ? '7' : '16'} z-30 justify-center flex w-full transition-all ease-linear delay-500`}>
      <div className="bg-white bg-opacity-50 backdrop-blur-md border border-white border-opacity-20 px-3 justify-center flex rounded-b-xl">
        <img src={darkLogo} width={isHome ? 80 : 140} />
      </div>
    </div>
  );
};

export default Header;
